class subscriptionWidget extends HTMLElement {
    constructor() {
        super();
        this.querySelector('.delivery__options').addEventListener('change', this.changeSellingPlan.bind(this));
        this.querySelectorAll('.option_container').forEach(option => option.addEventListener('click', () => this.changePurchaseType(option)));
        this.querySelector('add-to-cart').addEventListener('click', this.addToCart.bind(this));
    }
    changeSellingPlan(event) {
        this.dataset.currentSellingPlanId = event.target.value;
    }
    changePurchaseType(element) {
        this.dataset.currentPurchaseType = element.getAttribute('data-purchase_type');
    }
    addToCart() {
        const { quantity } = this.querySelector('quantity-input').dataset;
        
        const { 
            currentPurchaseType,
            currentSellingPlanId,
            currentVariantId
        } = this.dataset;
    
        const addToCartUrl = "/cart/add.js";

        var data = {
            id: currentVariantId,
            quantity: quantity
        }

        if (currentPurchaseType == "subscription") {
            data = {
                selling_plan: currentSellingPlanId,
                ...data
            }
        }

        fetch(addToCartUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({items: [data]})
        })
        .then(res => res.json())
        .then(data => console.log(data))
        .catch(error => console.log(error));
        
    }
}
customElements.define('subscription-widget', subscriptionWidget);

class onetimeWidget extends HTMLElement {
    constructor() {
        super();
        this.querySelector('add-to-cart').addEventListener('click', this.addToCart.bind(this));
    }
    addToCart() {
        const { quantity } = this.querySelector('quantity-input').dataset;
        
        const { 
            currentVariantId
        } = this.dataset;
    
        const addToCartUrl = "/cart/add.js";

        var data = {
            id: currentVariantId,
            quantity: quantity
        }

        fetch(addToCartUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({items: [data]})
        })
        .then(res => res.json())
        .then(data => console.log(data))
        .catch(error => console.log(error));        
    }
}
customElements.define('onetime-widget', onetimeWidget);

class quantitySelector extends HTMLElement {
    quantityBox;
    constructor() {
        super();
        this.querySelector('.plus-button').addEventListener('click', this.increaseQuantity.bind(this));
        this.querySelector('.minus-button').addEventListener('click', this.decreaseQuantity.bind(this));
        this.quantityBox = this.querySelector('span');
    }
    increaseQuantity() {
        const { quantity } = this.dataset;
        this.dataset.quantity = parseInt(quantity) + 1;
        this.quantityBox.innerHTML = this.dataset.quantity;
    }
    decreaseQuantity() {
        const { quantity } = this.dataset;
        this.dataset.quantity = Math.max(1, quantity - 1);
        this.quantityBox.innerHTML = this.dataset.quantity;
    }
}
customElements.define('quantity-input', quantitySelector);

// window.SLIDECART_LOADED = function(cart) {
//   const currentURL = new URL(window.location.href);
//   const hasOpenSliderParam = currentURL.searchParams.has("openSlider");
//   const isOpenSliderTrue = hasOpenSliderParam && currentURL.searchParams.get("openSlider") === "true";
  
//   if (isOpenSliderTrue) {
//     window.SLIDECART_OPEN()
//   }
// }

// window.SLIDECART_UPDATED = function(cart) {
//   const body = document.querySelector('body');
//   const cartIcon = document.querySelector('.cart-link__bubble');
//   const cartCount = document.querySelector('.cart-link__count');

//   cartCount.textContent = cart.item_count;
  
//   if (cart.item_count > 0) {
//     body.classList.add('cart-has-items');
//     cartIcon.classList.add('cart-link__bubble--visible');
//   } else {
//     body.classList.remove('cart-has-items');
//     cartIcon.classList.remove('cart-link__bubble--visible');
//   }
// }

$(document).ready(function(){
  var interval = setInterval(function() {
    if($("subscription-widget").length) {
      var savedPercents = $(".saved-percents-text").html();
      $(".subscription-discount").html(savedPercents);
      clearInterval(interval);
    }
  },100);

  $('.announcement__text-marquee').slick({
    dots: false,
    infinite: true,
    speed: 600,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    arrows: false
  });
});